export const securedLenderNames: string[] = [
    'Accord Mortgages',
    'Accredo',
    'Acenden',
    'Adam and Company',
    'Agricultural Mortgage Corporation',
    'Ahli United Bank',
    'Al Rayan Bank',
    'Aldermore Bank',
    'Amber Homeloans',
    'Arrow Global',
    'Atom Bank',
    'Axis Bank',
    'Bank Frick & Co.',
    'Bank of China',
    'Bank of Ireland',
    'Bank of Scotland',
    'Barclays',
    'Bath Building Society',
    'Beverly Building Society',
    'Birmingham Midshires',
    'Bluerock Finance (Alfandari)',
    'Bluestone',
    'Bluestone Mortgages',
    'BM Solutions',
    'Brown Shipley Private Bank',
    'Buckinghampshire Building Society',
    'BuildLoan',
    'Cambridge Building Society',
    'Capital Home Loans',
    'Castle Trust',
    'Central Trust',
    'Charter Court Financial Services',
    'Chelsea Building Society',
    'Cheltenham & Gloucester',
    'CHL Mortgages',
    'Chorley and District Building Society, The',
    'Chorley Building Society',
    'Clydesdale',
    'Co-Operative Bank, The',
    'Co-operative Financial Services',
    'Coutts & Company',
    'Coventry',
    'Credit Suisse',
    'Cumberland Building Society',
    'Cumberland, The',
    'Dankse Bank',
    'Darlington Building Society',
    'Dashly',
    'Digital Mortgages',
    'Dudley Building Society',
    'Early Shipton Building Society',
    'Ecology Building Society',
    'Elderbridge',
    'Equifinance',
    'Engage Credit',
    'Eurosail',
    'Evolution Money',
    'Family Building Society',
    'Finsec',
    'First Active',
    'First Direct',
    'First Trust Bank',
    'Fleet Mortgages',
    'Foundation Homeloans',
    'Furness',
    'GE Money',
    'Godiva Mortgages',
    'Habito',
    'Halifax',
    'Handelsbanken',
    'Hanley Economic Building Society',
    'Harpenden Building Society',
    'Harrods Bank',
    'Hinckley & Rugby Building Society',
    'Hodge Lifetime',
    'Holmesdale Building Society',
    'HSBC',
    'IDEM Capital',
    'Intelligent Finance',
    'InterBay Commercial',
    'Investec',
    'Ipswich Building Society',
    'JP Morgan Chase Bank',
    'Kensington',
    'Kent Reliance',
    'Keystone Property Finance',
    'Landbay',
    'Landmark Mortgages',
    'L&C',
    'Leeds Building Society',
    'Leek United Building Society',
    'Lloyds',
    'Loughborough Building Society',
    'Magellan Homeloans',
    'Mansfield',
    'Market Harborough Building Society',
    'Marsden Building Society',
    'Masthaven Bank',
    'Melanite Mortgages',
    'Melton Mowbray Building Society',
    'Metro Bank',
    'Mojo Mortgages',
    'Monmouthshire Building Society',
    'Mortgage Agency Services',
    'Mortgage Business, The',
    'Mortgage Express',
    'Mortgage Gym',
    'Mortgage Lender, The',
    'Mortgage Trust',
    'Mortgage Works, The',
    'Mortgages PLC',
    'M&S Bank',
    'National Counties Building Society',
    'Nationwide Building Society',
    'Natwest',
    'Natwest Business Accounts',
    'NatWest International',
    'NatWest Off-Set',
    'NEMO Personal Finance',
    'New Street Mortgages',
    'Newbury Building Society',
    'Newcastle Building Society',
    'North Yorkshire Mortgages',
    'Norton Home Loans',
    'Nottingham Building Society',
    'NRAM',
    'Oakwood Homeloans A',
    'Oakwood Homeloans B',
    'OneSavings Bank',
    'Optimum Credit',
    'Paragon Bank',
    'Penrith Building Society',
    'Pepper Homeloans',
    'Picture Home Loans',
    'Platform Funding',
    'Post Office',
    'Precise Mortgages',
    'Principality Building Society',
    'Progressive Building Society',
    'Progressive Society, The',
    'Proportunity',
    'RateSwitch',
    'Redstone Mortgages',
    'Rooftop Mortgages',
    'Rosinca Mortgages',
    'Royal Bank of Scotland',
    'Saffron Building Society',
    "Sainsbury's Bank",
    'Santander',
    'Scottish Building Society',
    'Scottish Widows',
    'Secure Trust Bank',
    'Shawbrook Bank',
    'Siberite Mortgages',
    'Skipton Building Society',
    'Skipton International',
    'Southern Pacific Mortgages',
    'Spring Finance',
    'St James Place Bank',
    'Stafford Railway Building Society',
    'State Bank of India',
    'Swansea Building Society',
    'Teachers Building Society',
    'Tesco Bank',
    'The Mortgage Lender',
    'Tipton & Coseley Building Society',
    'Together Money',
    'Together Personal Finance',
    'Topaz Finance',
    'Trillium',
    'Trussle',
    'TSB Bank',
    'UBS Private Bank',
    'UCB Home Loans',
    'Ulster Bank',
    'United Trust Bank',
    'Vernon Building Society',
    'Vida Homeloans',
    'Virgin Money',
    'Wave Lending Group',
    'WestOne',
    'West Brom, The',
    'Whistletree Mortgage',
    'Woolwich',
    'Yorkshire Bank',
    'Yorkshire Building Society',
    'Other',
];
